import { getFundingProgramProperties } from "@outschool/funding-programs-shared";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";

type UseConcierge = {
  canAccessConcierge: boolean;
};

export default function useConcierge(): UseConcierge {
  const { currentUser, isLoggedIn } = useSession();

  const esaState = useFundingProgramAbbr();
  const fundingProgramProperties = getFundingProgramProperties(esaState);
  const isClassWalletProgram = fundingProgramProperties?.isClassWallet;

  const canAccessConcierge =
    isLoggedIn &&
    (currentUser?.hasSubscription ||
      currentUser?.hasEsaMembership ||
      isClassWalletProgram);

  return {
    canAccessConcierge: !!canAccessConcierge,
  };
}
